export default [
    {
        path: '/sign/sign',
        component: (resolve) => require(['@/components/sign/Sign'],resolve),
        name:'webSign',
        meta:{
            title:'登录',
            exclude:'sign',
            share:true,
        }
    },
    {
        path: '/sign/we-chart',
        component: (resolve) => require(['@/components/sign/WeChart'],resolve),
        name:'weChartSign',
        meta:{
            title:'登录',
            exclude:'sign',
            share:true,
        }
    },
    {
        path: '/sign/register',
        component: (resolve) => require(['@/components/sign/Register'],resolve),
        name:'register',
        meta:{
            title:'验证码登录',
            exclude:'sign',
            share:true,
        }
    },
    {
        path: '/sign/verific',
        component: (resolve) => require(['@/components/sign/Verific'],resolve),
        meta:{
            title:'验证码登录',
            exclude:'sign',
            share:true,
        }
    },
    {
        path: '/sign/set-password',
        component: (resolve) => require(['@/components/sign/SetPassword'],resolve),
        meta:{
            title:'注册',
            exclude:'sign',
            share:true,
        }
    },

]



// WEBPACK FOOTER //
// ./src/router/sign.js